<template >
   <template
      v-if="inputObj.val && Object.keys(inputObj.val).length > 0"
  >

    <div class="card widget-card bsb-timeline-8 border-light shadow-sm">
      <div class="card-body p-4">
        <ul class="timeline">
          <li
              v-for="(historyItem, historyIndex) in inputObj.val"
              class="timeline-item"
          >
            <div class="timeline-body">
              <div class="timeline-meta">
                <span class="date">
                    {{ formattedDate(historyItem.time) }}<br/>
                    <small class="text-muted">{{ formattedTime(historyItem.time) }}</small>
                </span>

              </div>
              <div class="timeline-content timeline-indicator">
                <template
                    v-for="(boxItem, boxIndex) in historyItem.box.items"
                >
                  <span
                    v-if="boxItem.type == 'text'"
                    class="text-secondary fs-7 d-block"
                  >
                    {{boxItem.title}}: {{boxItem.value}}

                  </span>
                  <span
                      v-else-if="boxItem.type == 'bool'"
                      class="text-secondary fs-7 d-block"
                  >
                    {{boxItem.title}}:
                    <i
                        v-if="boxItem.value"
                        class="bi bi-check-circle-fill  text-success"
                    ></i>
                    <i
                        v-else
                        class="bi bi-x-circle-fill text-warning"
                    ></i>

                  </span>

                  <pre
                    v-else
                  >
                    {{boxItem}}
                  </pre>
                </template>
<!--
                <h6 class="mb-1">Amount received in the PayPal gateway.</h6>
                <span class="text-secondary fs-7">User: William Lucas</span>
-->

              </div>
            </div>

          </li>


        </ul>
      </div>
    </div>




  </template>
  <div
    v-else
  >
    Neni zadny zaznam k zobrazeni

  </div>

  <!--

  <display-debug>
    <template #debugView>inputObj {{inputObj.val}}</template>
  </display-debug>
-->
</template>

<script>
import multiselect  from 'vue-multiselect'
export default {
  name: "HistoryInput",
  components: {
    multiselect,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, String, Number],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: {},
      selectModel: null,
      options:[],
      optionsArr:[],
    }
  },
  mounted() {

  },
  methods: {
    formattedTime(datetime) {
     return new Intl.DateTimeFormat(this.$i18n.locale, {
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23' // zajišťuje 24h formát
      }).format(new Date(datetime.date));

    },
    formattedDate(datetime) {
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(new Date(datetime.date));
    },
  },


  watch: {
    inputModel: {
      handler(newVal) {
        //this.$emit('update:modelValue', JSON.stringify(newVal))
        this.$emit('update:modelValue', newVal)
      },
      deep: true,
      immediate: true
    },
  },
};
</script>
<style scoped type="text/scss">
.fs-7 {
  font-size: .875rem !important
}

.bsb-timeline-8 {
  --bsb-tl-color: var(--bs-secondary-bg-subtle);
  --bsb-tl-circle-color: var(--bs-light);
  --bsb-tl-circle-border-color: var(--bs-secondary);
  --bsb-tl-indicator-color: var(--bs-white);
  --bsb-tl-circle-size: 16px;
  --bsb-tl-circle-offset: 8px;
  --bsb-tl-circle-border-size: 1px
}

.bsb-timeline-8 .timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline:after {
  background-color: var(--bsb-tl-color);
  bottom: 0;
  content: "";
  left: 0;
  margin-left: -1px;
  position: absolute;
  top: 0;
  width: 2px
}

@media (min-width: 768px) {
  .bsb-timeline-8 .timeline:after {
    left: 20%;
    /*left: 33%*/
  }
}

.bsb-timeline-8 .timeline > .timeline-item {
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline > .timeline-item:after {
  background: var(--bsb-tl-circle-color);
  border: var(--bsb-tl-circle-border-size) solid var(--bsb-tl-circle-border-color);
  border-radius: 50%;
  content: "";
  height: var(--bsb-tl-circle-size);
  left: calc(var(--bsb-tl-circle-offset) * -1);
  position: absolute;
  top: calc(50% - var(--bsb-tl-circle-offset));
  width: var(--bsb-tl-circle-size);
  z-index: 1
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-body {
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-meta {
  padding: 0 0 1rem 2rem
}

.bsb-timeline-8 .timeline > .timeline-item:first-child .timeline-meta {
  padding: 2rem 0 1rem 2rem
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-content {
  padding: 0 0 2rem 2rem
}

@media (min-width: 768px) {
  .bsb-timeline-8 .timeline > .timeline-item {
    left: 20%;
    /*left: 33%;   */
    width: 67%
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-meta {
    display: flex;
    justify-content: flex-end;
    left: -100%;
    margin: 0;
    padding: 0 2rem 0 0;
    position: absolute;
    top: calc(50% - 10px);
    width: 100%;
    z-index: 1
  }

  .bsb-timeline-8 .timeline > .timeline-item:first-child .timeline-meta {
    padding: 0 2rem 0 0
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-content {
    padding: 2rem
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-indicator {
    position: relative
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-indicator:after {
    border-width: 1px;
    border: 10px solid var(--bsb-tl-indicator-color);
    border-color: transparent var(--bsb-tl-indicator-color) transparent transparent;
    border-left-width: 0;
    content: "";
    left: calc(2rem - 10px);
    position: absolute;
    top: calc(50% - var(--bsb-tl-circle-offset));
    z-index: 1
  }
}
</style>